import { LoanCrud } from "./loanCrud";

export default function AllLoan(){
    return <LoanCrud name="全部按揭" type="all" router="loans" />
}